import { Actions as AppActions } from "./actions";

const initialState = {
  loading: true,
};

const appReducer = (state = initialState, action) => {
  switch (action.type) {
    case AppActions.APP_LOADING:
      return {
        ...state,
        loading: action.value,
      };
    default:
      return state;
  }
};

export default appReducer;
